import { memo } from "react";
import PropTypes from "prop-types";
import "./SanitaryMessage.scss";
import { FormattedMessage } from "react-intl";
import MoreDetails from "app/pages/.shared/MoreDetails";
import Paragraphs from "app/pages/.shared/Paragraphs";
import isEmpty from "lodash/isEmpty";
import { LessIcon, MoreIcon } from "app/icons/navigation";
import { ICON_SIZES } from "app/constants";

const SanitaryMessage = ({ intro, details }) => {
	return (
		(!isEmpty(intro) || !isEmpty(details)) && (
			<div className="sanitary-message">
				<Paragraphs paragraphs={intro} enableHTMLFormatting />

				{details.length > 0 && (
					<div className="sanitary-message__details">
						<MoreDetails
							expandedIcon={<LessIcon size={ICON_SIZES.XS} />}
							collapsedIcon={<MoreIcon size={ICON_SIZES.XS} />}
							expandedLabel={<FormattedMessage id="product.page.less.details" />}
							collapsedLabel={<FormattedMessage id="product.page.more.details" />}
							headerPosition={"bottom"}
						>
							<Paragraphs paragraphs={details} enableHTMLFormatting />
						</MoreDetails>
					</div>
				)}
			</div>
		)
	);
};

SanitaryMessage.propTypes = {
	intro: PropTypes.array,
	details: PropTypes.array,
};

SanitaryMessage.defaultProps = {
	intro: [],
	details: [],
};

export default memo(SanitaryMessage);
